import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TeacherStudentHeader.css";
import anavuLogo from "../images/iiit_logo.png";
// import { getToken } from "../Storage/Storage";

import userIcon from "../images/user_icon.png";
import logoutIcon from "../images/logoutIcon.png";
import { getName, setToken, setName, setUserID } from "../Storage/Storage";

const TeacherStudentHeader = ({
  isVideoMode,
  toggleMode,
  showSearch,
  teacherMenuItems,
  showToggle,
  showUserProfile,
  onSearch,
  searchQuery,
  setActiveItem, // Passed from parent
  activeItem, // Passed from parent
  onOpenWebVersionModal,
}) => {
  const [name, setNameState] = useState("");
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();
  //   const [setOpen] = useState(false);
  const [isThrottled] = useState(false);

  useEffect(() => {
    const fetchName = async () => {
      try {
        const userName = await getName();
        setNameState(userName);
      } catch (error) {
        console.error("Failed to fetch name", error);
      }
    };
    fetchName();
  }, []);

  const handleActiveItemChange = (itemKey) => {
    setActiveItem(itemKey); // Update parent state
  };

  const handleLogout = async () => {
    try {
      await setToken("");
      await setName("");
      await setUserID("");
      console.log("User logged out");
      navigate("/");
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  return (
    <header className="header">
      <div className="logo-container">
        <a href="/">
          <img src={anavuLogo} alt="Anavu Logo" className="logo" />
          <div className="logo-text">AnaVu</div>
        </a>
      </div>

      <div className="navbar-right">
        {teacherMenuItems.map((item) => (
          <span
            key={item.label}
            className={`navbar-link ${
              item.key === activeItem ? "active" : ""
            } ${item.disabled ? "disabled" : ""}`}
            onClick={() => {
              if (!item.disabled) {
                if (item.onClick) {
                  item.onClick(); // Trigger custom onClick handler
                } else {
                  handleActiveItemChange(item.key);
                }
              }
            }}
          >
            {item.label}
          </span>
        ))}

        <div className="header-user-profile">
          {showUserProfile && (
            <>
              <div className="header-user-name">{name || "Loading..."}</div>
              <img
                src={userIcon}
                alt="User Icon"
                className="header-user-icon"
                onClick={() => setShowLogout(!showLogout)}
                style={{ cursor: "pointer" }}
              />
              {showLogout && (
                <button className="logout-button" onClick={handleLogout}>
                  {/* onClick={onOpenWebVersionModal} */}
                  <div className="logout-icon">
                    <img
                      src={logoutIcon}
                      alt="Logout Icon"
                      className="logout-icon"
                    />
                  </div>
                  <div className="logout-text">Logout</div>
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default TeacherStudentHeader;
